import React, {useState} from "react";

/**
 * NewUserAvatar
 * - Circular
 * - Fondo plano #122436 para avatares con transparencia
 * - Acepta sizes: "sm" | "md" | "lg" (por defecto "md")
 * - No rompe el layout del header
 */
export default function NewUserAvatar({ user, size = "md", className = "" }) {
    const [imageError, setImageError] = useState(false);
    
    const isLocalAvatar = user.image?.match(/^\d+\.png$/);
    const imageSrc = isLocalAvatar ? `/images/avatares/${user.image}` : user.image;
    const shouldShowImage = !!imageSrc && !imageError;

    const sizeMap = {
        sm: "w-7 h-7",   // 28px
        md: "w-8 h-8",   // 32px (match header)
        lg: "w-10 h-10", // 40px
    };
    const box = sizeMap[size] || sizeMap.md;

    // Si no hay imagen, uso inicial del username
    const initial =
        (user?.username || user?.name || "U").trim().charAt(0).toUpperCase();

    return (
        <div
            className={[
                "relative shrink-0 rounded-full overflow-hidden",
                "bg-[#122436]",          // ← fondo pedido
                "ring-1 ring-white/10",  // sutileza como en el mock
                box,
                className,
            ].join(" ")}
            aria-label={user?.username || "Usuario"}
        >
            {shouldShowImage ? (
                <img
                    src={imageSrc}
                    alt={user.username}
                    className="w-full h-full object-contain select-none pointer-events-none"
                    draggable={false}
                    onError={() => {
                        console.log(`Error cargando imagen de ${user.username}:`, user.image);
                        setImageError(true);
                    }}
                />
            ) : (
                <span className="w-full h-full grid place-items-center text-white/80 text-xs font-semibold">
          {initial}
        </span>
            )}
        </div>
    );
}
